import { render } from "./PayrollSetupManagement.vue?vue&type=template&id=da397bcc&scoped=true"
import script from "./PayrollSetupManagement.vue?vue&type=script&lang=js"
export * from "./PayrollSetupManagement.vue?vue&type=script&lang=js"

import "./PayrollSetupManagement.vue?vue&type=style&index=0&id=da397bcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da397bcc"]])

export default __exports__